import { ROUTES } from '@/common/auth-routes';

// Derived from the dock's own links: a surface the dock points at that does not
// render it strands the user with no way back.
const MOBILE_NAV_SURFACES: string[] = [
  ROUTES.DASHBOARD,
  ROUTES.AGENTS,
  ROUTES.MCP_TESTER,
];

export function hasMobileNav(pathname: string, mcpTesterVisible: boolean) {
  const [, , surface] = pathname.split('/');

  // The tester's route redirects when its gate is off, so mounting the dock on
  // the pathname alone flashes one onto a page nobody can reach.
  if (`/${surface}` === ROUTES.MCP_TESTER) {
    return mcpTesterVisible;
  }

  return MOBILE_NAV_SURFACES.includes(`/${surface}`);
}
